import { ESdChangeReason, IWorkFlow } from "@kuika/kuika-cl-model";
import { withSD } from "../../../../shared/hoc/screen-design-consumer";
import { withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { WorkflowAssignmentProperties } from "./wf-utils/workflow-assignment-properties";

export interface IWorkFlowLanePropertiesState {
  // isDynamicAssignment: boolean;
}

export interface IWorkFlowLanePropertiesProps {
  selectedNodeId: string | undefined;
  assignmenChangeHandler: (lane, newAssignment) => void;
}

class WorkFlowLaneProperties extends PureSdComponent<IWorkFlowLanePropertiesProps, IWorkFlowLanePropertiesState> {
  constructor(props) {
    super(props);
  }

  handleLaneAssignmentChange = (assignment) => {
    const selectedWF: IWorkFlow | undefined = this.props.sd.selectedWf;
    const lane = selectedWF && selectedWF?.nodes?.lanes.find((l) => l.id === this.props.selectedNodeId);
    this.props.assignmenChangeHandler(lane, assignment);
  };

  getSelectedLaneAssignment = () => {
    const wf: IWorkFlow | undefined = this.props.sd.selectedWf;
    const lane = wf && wf?.nodes?.lanes.find((l) => l.id === this.props.selectedNodeId);
    return this.props.sd.getAssignmentTypeValue(lane?.assignment.assignmentType);
  };

  render() {
    const wf: IWorkFlow | undefined = this.props.sd.selectedWf;
    const lane = wf && wf?.nodes?.lanes.find((l) => l.id === this.props.selectedNodeId);
    // const roles: IProjectRole[] = this.getRoles();
    if (wf && lane) {
      return (
        <div className="kuika__workflow__properties">
          <div className="kuika_workflow-properties__section">
            <WorkflowAssignmentProperties
              wf={wf}
              nodeAssignment={lane.assignment}
              onNodeAssignmentDataChanged={(node) => this.handleLaneAssignmentChange(node)}
              disabled={false}
            ></WorkflowAssignmentProperties>
          </div>
        </div>
      );
    }
    return <></>;
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.SaveWorkflow ||
      changeReason === ESdChangeReason.ClickWfDesignXmlNode ||
      changeReason === ESdChangeReason.WFStepMappingChange
    ) {
      return true;
    }
    return false;
  };
}

const workFlowLaneProperties = withContext<IWorkFlowLanePropertiesProps>(
  withSD<IWorkFlowLanePropertiesProps>(WorkFlowLaneProperties)
);
export { workFlowLaneProperties as WorkFlowLaneProperties };
